import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'amp-text-section-grid',
  styleUrls: ['../../base.css'],
  shadow: true,
})
export class AmpTextSectionGrid {
  /**
   * The number of columns used to display Text Section Blocks in a given row beyond the md screen size.
   */
  @Prop() numberOfCols: number;

  render() {
    const cols = this.numberOfCols;

    return (
      <div class={`grid grid-cols-1 md:grid-cols-${cols} gap-8`}>
        <slot />
      </div>
    );
  }
}
